var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"app-container"},[_c('div',{staticClass:"page-title"}),_c('el-card',{staticClass:"box-card"},[_c('article-detail',{attrs:{"is-edit":true}})],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }